(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-accessories"] && !Shopify.designMode) return;
  try {
    
  window.PPCart = window.PPCart || (function () {
    function drawer() { return document.querySelector('cart-drawer'); }
    function sectionsParam(d) {
      var s = 'cart-icon-bubble';
      if (d) { var sec = d.closest('.shopify-section'); if (sec) s += ',' + sec.id.replace('shopify-section-', ''); }
      return s;
    }
    function route() { return (window.theme && theme.routes && theme.routes.cartAdd) ? theme.routes.cartAdd : '/cart/add.js'; }
    /* Shared tail for both add paths: refresh the bubble + drawer, bump, announce. */
    function applyCart(data, d) {
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble && data.sections && data.sections['cart-icon-bubble']) bubble.innerHTML = data.sections['cart-icon-bubble'];
      if (d && typeof d.renderContents === 'function') {
        try { d.renderContents(data, false); } catch (err) { if (typeof d.refresh === 'function') { try { d.refresh(true); } catch (e2) {} } }
      }
      bump();
      document.dispatchEvent(new CustomEvent('on:cart:add', { bubbles: true, detail: { cart: data } }));
      return data;
    }
    async function add(items) {
      var d = drawer();
      var res = await fetch(route(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items, sections: sectionsParam(d), sections_url: window.location.pathname })
      });
      var data = await res.json();
      if (!res.ok) throw data;
      return applyCart(data, d);
    }
    /* A file can only reach a line item property through a MULTIPART body, so an
       upload cannot ride add()'s JSON. Deliberately sets no Content-Type — the
       browser must write its own multipart boundary. One item per call, which is
       all a file upload can be anyway. */
    async function addForm(fd) {
      var d = drawer();
      fd.append('sections', sectionsParam(d));
      fd.append('sections_url', window.location.pathname);
      var res = await fetch(route(), {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: fd
      });
      var data = await res.json();
      if (!res.ok) throw data;
      return applyCart(data, d);
    }
    function bump() {
      var i = document.getElementById('cart-icon');
      if (!i) return;
      i.classList.remove('pp-cart-bump'); void i.offsetWidth; i.classList.add('pp-cart-bump');
      setTimeout(function () { i.classList.remove('pp-cart-bump'); }, 700);
    }
    function reduced() { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
    function fly(img) {
      var icon = document.getElementById('cart-icon');
      if (!icon || !img || reduced()) return;
      var s = img.getBoundingClientRect(), t = icon.getBoundingClientRect();
      if (!s.width || !t.width) return;
      var c = img.cloneNode(true), st = c.style;
      st.position = 'fixed'; st.left = s.left + 'px'; st.top = s.top + 'px'; st.width = s.width + 'px'; st.height = s.height + 'px';
      st.margin = '0'; st.borderRadius = '12px'; st.objectFit = 'cover'; st.zIndex = '9999'; st.pointerEvents = 'none'; st.boxShadow = '0 10px 30px rgba(0,0,0,.25)';
      document.body.appendChild(c);
      var dx = (t.left + t.width / 2) - (s.left + s.width / 2), dy = (t.top + t.height / 2) - (s.top + s.height / 2);
      var a = c.animate([
        { transform: 'translate(0,0) scale(1)', opacity: 1 },
        { transform: 'translate(' + (dx * 0.5) + 'px,' + ((dy * 0.5) - 40) + 'px) scale(.6)', opacity: 0.95, offset: 0.6 },
        { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.12)', opacity: 0.2 }
      ], { duration: 750, easing: 'cubic-bezier(.5,0,.75,.4)' });
      a.onfinish = function () { c.remove(); };
    }
    return { add: add, addForm: addForm, fly: fly, bump: bump };
  })();

  window.PPCarousel = window.PPCarousel || (function () {
    function slides(track) { return Array.prototype.slice.call(track.children); }
    function activeIndex(track) {
      var s = slides(track); if (!s.length) return 0;
      var pad = parseFloat(getComputedStyle(track).scrollPaddingLeft) || 0;
      var ref = track.getBoundingClientRect().left + pad + 2;
      var best = 0, bestDist = Infinity;
      for (var i = 0; i < s.length; i++) {
        var d = Math.abs(s[i].getBoundingClientRect().left - ref);
        if (d < bestDist) { bestDist = d; best = i; }
      }
      return best;
    }
    function paint(dots, i) {
      if (!dots) return;
      Array.prototype.slice.call(dots.children).forEach(function (d, di) {
        var on = di === i; d.classList.toggle('is-active', on); d.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }
    function init(track) {
      if (!track || track.dataset.ppcBound === '1') return;
      track.dataset.ppcBound = '1';
      var dots = track.parentNode ? track.parentNode.querySelector('[data-pp-dots]') : null;
      var raf = 0;
      function sync() { paint(dots, activeIndex(track)); }
      track.addEventListener('scroll', function () { if (raf) return; raf = requestAnimationFrame(function () { raf = 0; sync(); }); }, { passive: true });
      if (dots) {
        dots.addEventListener('click', function (e) {
          var b = e.target.closest('[data-dot]'); if (!b) return;
          var t = slides(track)[parseInt(b.dataset.dot, 10) || 0];
          if (t && t.scrollIntoView) t.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        });
      }
      window.addEventListener('resize', function () { if (raf) return; raf = requestAnimationFrame(function () { raf = 0; sync(); }); });
      sync();
    }
    function boot() { var els = document.querySelectorAll('[data-pp-carousel]'); for (var i = 0; i < els.length; i++) init(els[i]); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
    return { init: init, boot: boot };
  })();

  (function () {
    if (window.__ppAccBound) return;
    window.__ppAccBound = true;
    function setLabel(btn, text) { var l = btn.querySelector('.pp-lbl'); if (l) l.textContent = text; else btn.textContent = text; }
    function qtyInput(card) { return card ? card.querySelector('.pp-qty__input') : null; }
    function readQty(card) { var inp = qtyInput(card); var n = inp ? parseInt(inp.value, 10) : 1; if (!n || n < 1 || isNaN(n)) n = 1; return n; }
    function syncQty(inp) {
      var n = parseInt(inp.value, 10); if (!n || n < 1 || isNaN(n)) n = 1; inp.value = n;
      var wrap = inp.closest('.pp-qty'); if (wrap) { var dec = wrap.querySelector('[data-qty-dec]'); if (dec) dec.disabled = (n <= 1); }
    }
    function stepQty(btn, delta) {
      var wrap = btn.closest('.pp-qty'); if (!wrap) return;
      var inp = wrap.querySelector('.pp-qty__input'); if (!inp) return;
      var floor = parseInt(inp.min, 10) || 1;
      var n = parseInt(inp.value, 10); if (!n || isNaN(n)) n = floor;
      n += delta; if (n < floor) n = floor; inp.value = n; syncQty(inp);
      updateTiers(btn.closest('.pp-acc__card'));
    }

    /* ---- tiered pricing, ported from pp-single-items ---- */
    function ppMoney(cents, cur) {
      try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur || 'USD' }).format((cents || 0) / 100); }
      catch (e) { return '$' + ((cents || 0) / 100).toFixed(2); }
    }
    function updateTiers(card) {
      if (!card) return;
      var box = card.querySelector('[data-pp-tiers]'); if (!box) return;
      var onlyVid = box.dataset.variantId || '';
      var activeVar = card.querySelector('.pp-acc__variant.is-active');
      var atcBtn = card.querySelector('.pp-acc__atc');
      var selVid = (activeVar && activeVar.dataset.variantId) || (atcBtn && atcBtn.dataset.variantId) || '';
      var cur = box.dataset.currency || 'USD';
      var cents = parseInt(box.dataset.base, 10) || 0;
      var shown = [];
      Array.prototype.slice.call(box.querySelectorAll('.pp-acc__tier')).forEach(function (r) {
        var rv = r.dataset.variantId || '';
        var show = rv ? (rv === selVid) : (!onlyVid || onlyVid === selVid);
        r.hidden = !show;
        r.classList.remove('is-active');
        if (show) shown.push(r);
      });
      box.hidden = shown.length === 0;

      /* The lowest visible tier IS this variant's order minimum, so the stepper
         cannot be walked below it - otherwise a 100-cap method could be added
         one unit at a time. */
      var inp = qtyInput(card);
      var floor = 1;
      shown.forEach(function (r) {
        var m = parseInt(r.dataset.min, 10) || 0;
        if (m && (floor === 1 || m < floor)) floor = m;
      });
      if (inp) {
        inp.min = floor;
        if ((parseInt(inp.value, 10) || 0) < floor) inp.value = floor;
        var dec = card.querySelector('[data-qty-dec]');
        if (dec) dec.disabled = (parseInt(inp.value, 10) || floor) <= floor;
      }

      var qty = readQty(card);
      var active = null, bestMin = -1;
      shown.forEach(function (r) {
        var min = parseInt(r.dataset.min, 10) || 0;
        if (qty >= min && min > bestMin) { bestMin = min; active = r; }
      });
      if (active) { active.classList.add('is-active'); cents = parseInt(active.dataset.cents, 10) || cents; }
      var note = box.querySelector('[data-pp-tier-note]');
      if (note) note.textContent = cents > 0 ? (qty + ' \u00d7 ' + ppMoney(cents, cur) + ' each = ' + ppMoney(cents * qty, cur)) : '';
    }
    function selectVariant(btn) {
      if (btn.disabled) return;
      var card = btn.closest('.pp-acc__card'); if (!card) return;
      var group = btn.closest('.pp-acc__variants');
      if (group) {
        Array.prototype.slice.call(group.querySelectorAll('.pp-acc__variant')).forEach(function (b) {
          var on = b === btn;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-checked', on ? 'true' : 'false');
        });
      }
      var atc = card.querySelector('.pp-acc__atc');
      if (atc && btn.dataset.variantId) atc.dataset.variantId = btn.dataset.variantId;
      var priceEl = card.querySelector('[data-pp-price]');
      if (priceEl && btn.dataset.price) priceEl.textContent = btn.dataset.price;
      var box = card.querySelector('[data-pp-tiers]');
      if (box && btn.dataset.priceCents) box.dataset.base = btn.dataset.priceCents;
      updateTiers(card);
    }
    function initAccTiers() { Array.prototype.slice.call(document.querySelectorAll('.pp-acc__card')).forEach(updateTiers); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAccTiers); else initAccTiers();
    document.addEventListener('shopify:section:load', initAccTiers);
    /* ---- artwork validation: same rules as the PDP calculator ---- */
    var ART_OK = ['png', 'jpg', 'jpeg', 'pdf', 'ai', 'eps', 'svg'];
    var ART_RASTER = ['png', 'jpg', 'jpeg'];
    var ART_MIN_PX = 1000;
    var ART_MAX_BYTES = 20 * 1024 * 1024;
    function fileMsgEl(card) { return card ? card.querySelector('[data-pp-filemsg]') : null; }
    function setFileMsg(card, kind, text) {
      var el = fileMsgEl(card); if (!el) return;
      el.hidden = !text;
      el.textContent = text || '';
      el.className = 'pp-acc__filemsg' + (kind ? ' is-' + kind : '');
    }
    function validateArtwork(inp) {
      var card = inp.closest('.pp-acc__card');
      var f = inp.files && inp.files[0];
      if (!f) { setFileMsg(card, '', ''); return; }
      var ext = (f.name.split('.').pop() || '').toLowerCase();
      if (ART_OK.indexOf(ext) === -1) {
        inp.value = '';
        setFileMsg(card, 'err', '.' + ext + ' files are not accepted. Use PNG, JPG, PDF, AI, EPS or SVG.');
        return;
      }
      if (f.size > ART_MAX_BYTES) {
        inp.value = '';
        setFileMsg(card, 'err', 'That file is ' + (f.size / 1048576).toFixed(1) + ' MB. Please keep it under ' + (ART_MAX_BYTES / 1048576) + ' MB.');
        return;
      }
      if (ART_RASTER.indexOf(ext) === -1) { setFileMsg(card, 'ok', f.name); return; }
      var url = URL.createObjectURL(f);
      var im = new Image();
      im.onload = function () {
        var w = im.naturalWidth, h = im.naturalHeight;
        URL.revokeObjectURL(url);
        if (Math.min(w, h) < ART_MIN_PX) {
          setFileMsg(card, 'warn', w + ' \u00d7 ' + h + ' px \u2014 under ' + ART_MIN_PX + ' px on the shortest side, so it may print soft. A larger image or a vector file is better.');
        } else {
          setFileMsg(card, 'ok', f.name + ' \u2014 ' + w + ' \u00d7 ' + h + ' px');
        }
      };
      im.onerror = function () { URL.revokeObjectURL(url); setFileMsg(card, 'ok', f.name); };
      im.src = url;
    }

    async function handleAtc(btn) {
      if (btn.disabled || btn.getAttribute('aria-disabled') === 'true' || btn.dataset.busy === '1') return;
      var vid = btn.dataset.variantId; if (!vid) return;
      var card = btn.closest('.pp-acc__card'); var img = card ? card.querySelector('.pp-acc__img') : null;
      var qty = readQty(card);

      /* Artwork is required on this card exactly as it is on the PDP — refuse the
         add rather than create a line item nobody can fulfil. */
      var fileInp = card ? card.querySelector('[data-pp-file]') : null;
      var hasFile = !!(fileInp && fileInp.files && fileInp.files[0]);
      if (fileInp && fileInp.hasAttribute('data-pp-file-required') && !hasFile) {
        setFileMsg(card, 'err', 'Please attach your artwork before adding to cart.');
        try { fileInp.focus(); } catch (e) {}
        return;
      }
      var original = btn.dataset.label || 'Add to Cart';
      btn.dataset.busy = '1'; btn.classList.add('is-loading');
      if (img) window.PPCart.fly(img);
      try {
        if (hasFile) {
          var fd = new FormData();
          fd.append('id', vid);
          fd.append('quantity', qty);
          fd.append('properties[' + (fileInp.dataset.ppProp || 'Artwork') + ']', fileInp.files[0]);
          /* The variant option is already named "Branding Method", and the cart
             renders options AND properties, so repeating it here printed the
             method twice on the line item. */
          await window.PPCart.addForm(fd);
          fileInp.value = '';
          setFileMsg(card, '', '');
        } else {
          await window.PPCart.add([{ id: vid, quantity: qty }]);
        }
        btn.classList.add('is-added'); setLabel(btn, btn.dataset.added || 'Added!');
        var inp = qtyInput(card); if (inp) { inp.value = parseInt(inp.min, 10) || 1; syncQty(inp); updateTiers(card); }
        setTimeout(function () { btn.classList.remove('is-added'); setLabel(btn, original); }, 3000);
      } catch (e) {
        setLabel(btn, 'Try again'); setTimeout(function () { setLabel(btn, original); }, 2000);
      } finally { btn.classList.remove('is-loading'); btn.dataset.busy = ''; }
    }
    function collectItems(container, fallbackIds) {
      var items = [];
      container.querySelectorAll('.pp-acc__card').forEach(function (card) {
        var atc = card.querySelector('.pp-acc__atc[data-variant-id]'); if (!atc) return;
        var id = atc.dataset.variantId; if (!id) return;
        items.push({ id: id, quantity: readQty(card) });
      });
      if (!items.length && fallbackIds) items = fallbackIds.map(function (id) { return { id: id, quantity: 1 }; });
      return items;
    }
    async function handleAddAll(btn) {
      if (btn.dataset.state === 'done') { window.location.href = btn.dataset.checkout || '/checkout'; return; }
      if (btn.dataset.busy === '1') return;
      var container = btn.closest('.pp-acc');
      var fallback = (btn.dataset.variantIds || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      var items = container ? collectItems(container, fallback) : fallback.map(function (id) { return { id: id, quantity: 1 }; });
      if (!items.length) return;
      btn.dataset.busy = '1'; btn.classList.add('is-loading');
      if (container) { container.querySelectorAll('.pp-acc__img').forEach(function (im, i) { setTimeout(function () { window.PPCart.fly(im); }, i * 120); }); }
      try {
        await window.PPCart.add(items);
        btn.dataset.state = 'done'; btn.classList.add('is-done'); setLabel(btn, btn.dataset.doneLabel || 'Added — check out now!');
      } catch (e) {
        setLabel(btn, 'Try again'); setTimeout(function () { setLabel(btn, btn.dataset.label || 'Add all to Cart'); }, 2000);
      } finally { btn.classList.remove('is-loading'); btn.dataset.busy = ''; }
    }
    document.addEventListener('click', function (e) {
      var dec = e.target.closest('.pp-acc [data-qty-dec]'); if (dec) { e.preventDefault(); stepQty(dec, -1); return; }
      var inc = e.target.closest('.pp-acc [data-qty-inc]'); if (inc) { e.preventDefault(); stepQty(inc, 1); return; }
      var vbtn = e.target.closest('.pp-acc__variant'); if (vbtn) { e.preventDefault(); selectVariant(vbtn); return; }
      var atc = e.target.closest('.pp-acc__atc'); if (atc) { e.preventDefault(); handleAtc(atc); return; }
      var all = e.target.closest('.pp-acc__addall'); if (all) { e.preventDefault(); handleAddAll(all); return; }
    });
    document.addEventListener('input', function (e) { var inp = e.target.closest('.pp-acc .pp-qty__input'); if (inp) updateTiers(inp.closest('.pp-acc__card')); });
    document.addEventListener('change', function (e) { var f = e.target.closest('[data-pp-file]'); if (f) validateArtwork(f); });
    document.addEventListener('change', function (e) { var inp = e.target.closest('.pp-acc .pp-qty__input'); if (inp) syncQty(inp); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-bundles"] && !Shopify.designMode) return;
  try {
    
  window.PPCart = window.PPCart || (function () {
    function drawer() { return document.querySelector('cart-drawer'); }
    function sectionsParam(d) {
      var s = 'cart-icon-bubble';
      if (d) { var sec = d.closest('.shopify-section'); if (sec) s += ',' + sec.id.replace('shopify-section-', ''); }
      return s;
    }
    function route() { return (window.theme && theme.routes && theme.routes.cartAdd) ? theme.routes.cartAdd : '/cart/add.js'; }
    /* Shared tail for both add paths: refresh the bubble + drawer, bump, announce. */
    function applyCart(data, d) {
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble && data.sections && data.sections['cart-icon-bubble']) bubble.innerHTML = data.sections['cart-icon-bubble'];
      if (d && typeof d.renderContents === 'function') {
        try { d.renderContents(data, false); } catch (err) { if (typeof d.refresh === 'function') { try { d.refresh(true); } catch (e2) {} } }
      }
      bump();
      document.dispatchEvent(new CustomEvent('on:cart:add', { bubbles: true, detail: { cart: data } }));
      return data;
    }
    async function add(items) {
      var d = drawer();
      var res = await fetch(route(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items, sections: sectionsParam(d), sections_url: window.location.pathname })
      });
      var data = await res.json();
      if (!res.ok) throw data;
      return applyCart(data, d);
    }
    /* A file can only reach a line item property through a MULTIPART body, so an
       upload cannot ride add()'s JSON. Deliberately sets no Content-Type — the
       browser must write its own multipart boundary. One item per call, which is
       all a file upload can be anyway. */
    async function addForm(fd) {
      var d = drawer();
      fd.append('sections', sectionsParam(d));
      fd.append('sections_url', window.location.pathname);
      var res = await fetch(route(), {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: fd
      });
      var data = await res.json();
      if (!res.ok) throw data;
      return applyCart(data, d);
    }
    function bump() {
      var i = document.getElementById('cart-icon');
      if (!i) return;
      i.classList.remove('pp-cart-bump'); void i.offsetWidth; i.classList.add('pp-cart-bump');
      setTimeout(function () { i.classList.remove('pp-cart-bump'); }, 700);
    }
    function reduced() { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
    function fly(img) {
      var icon = document.getElementById('cart-icon');
      if (!icon || !img || reduced()) return;
      var s = img.getBoundingClientRect(), t = icon.getBoundingClientRect();
      if (!s.width || !t.width) return;
      var c = img.cloneNode(true), st = c.style;
      st.position = 'fixed'; st.left = s.left + 'px'; st.top = s.top + 'px'; st.width = s.width + 'px'; st.height = s.height + 'px';
      st.margin = '0'; st.borderRadius = '12px'; st.objectFit = 'cover'; st.zIndex = '9999'; st.pointerEvents = 'none'; st.boxShadow = '0 10px 30px rgba(0,0,0,.25)';
      document.body.appendChild(c);
      var dx = (t.left + t.width / 2) - (s.left + s.width / 2), dy = (t.top + t.height / 2) - (s.top + s.height / 2);
      var a = c.animate([
        { transform: 'translate(0,0) scale(1)', opacity: 1 },
        { transform: 'translate(' + (dx * 0.5) + 'px,' + ((dy * 0.5) - 40) + 'px) scale(.6)', opacity: 0.95, offset: 0.6 },
        { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.12)', opacity: 0.2 }
      ], { duration: 750, easing: 'cubic-bezier(.5,0,.75,.4)' });
      a.onfinish = function () { c.remove(); };
    }
    return { add: add, addForm: addForm, fly: fly, bump: bump };
  })();

  window.PPCarousel = window.PPCarousel || (function () {
    function slides(track) { return Array.prototype.slice.call(track.children); }
    function activeIndex(track) {
      var s = slides(track); if (!s.length) return 0;
      var pad = parseFloat(getComputedStyle(track).scrollPaddingLeft) || 0;
      var ref = track.getBoundingClientRect().left + pad + 2;
      var best = 0, bestDist = Infinity;
      for (var i = 0; i < s.length; i++) {
        var d = Math.abs(s[i].getBoundingClientRect().left - ref);
        if (d < bestDist) { bestDist = d; best = i; }
      }
      return best;
    }
    function paint(dots, i) {
      if (!dots) return;
      Array.prototype.slice.call(dots.children).forEach(function (d, di) {
        var on = di === i; d.classList.toggle('is-active', on); d.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }
    function init(track) {
      if (!track || track.dataset.ppcBound === '1') return;
      track.dataset.ppcBound = '1';
      var dots = track.parentNode ? track.parentNode.querySelector('[data-pp-dots]') : null;
      var raf = 0;
      function sync() { paint(dots, activeIndex(track)); }
      track.addEventListener('scroll', function () { if (raf) return; raf = requestAnimationFrame(function () { raf = 0; sync(); }); }, { passive: true });
      if (dots) {
        dots.addEventListener('click', function (e) {
          var b = e.target.closest('[data-dot]'); if (!b) return;
          var t = slides(track)[parseInt(b.dataset.dot, 10) || 0];
          if (t && t.scrollIntoView) t.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        });
      }
      window.addEventListener('resize', function () { if (raf) return; raf = requestAnimationFrame(function () { raf = 0; sync(); }); });
      sync();
    }
    function boot() { var els = document.querySelectorAll('[data-pp-carousel]'); for (var i = 0; i < els.length; i++) init(els[i]); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
    return { init: init, boot: boot };
  })();

  (function () {
    if (window.__ppBundlesBound) return;
    window.__ppBundlesBound = true;
    function setLabel(btn, text) { var l = btn.querySelector('.pp-lbl'); if (l) l.textContent = text; else btn.textContent = text; }
    async function handleBuy(btn) {
      if (btn.disabled || btn.getAttribute('aria-disabled') === 'true' || btn.dataset.busy === '1') return;
      var vid = btn.dataset.variantId; if (!vid) return;
      var card = btn.closest('.pp-bn__card'); var img = card ? card.querySelector('.pp-bn__img') : null;
      var original = btn.dataset.label || 'Buy';
      btn.dataset.busy = '1'; btn.classList.add('is-loading');
      if (img) window.PPCart.fly(img);
      try {
        await window.PPCart.add([{ id: vid, quantity: 1 }]);
        btn.classList.add('is-added'); setLabel(btn, btn.dataset.added || 'Added!');
        setTimeout(function () { btn.classList.remove('is-added'); setLabel(btn, original); }, 3000);
      } catch (e) {
        setLabel(btn, 'Try again'); setTimeout(function () { setLabel(btn, original); }, 2000);
      } finally { btn.classList.remove('is-loading'); btn.dataset.busy = ''; }
    }
    document.addEventListener('click', function (e) {
      var b = e.target.closest('.pp-bn__buy'); if (b) { e.preventDefault(); handleBuy(b); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.pp-mobile-quote-bar').forEach((bar) => {
    const hero = bar.closest('.pp-hero');
    if (!hero || !('IntersectionObserver' in window)) { bar.classList.add('is-showing'); return; }
    new IntersectionObserver((entries) => { bar.classList.toggle('is-showing', !entries[0].isIntersecting); }, { threshold: 0 }).observe(hero);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-protection"] && !Shopify.designMode) return;
  try {
    
  window.PPCarousel = window.PPCarousel || (function () {
    function slides(track) { return Array.prototype.slice.call(track.children); }
    function activeIndex(track) {
      var s = slides(track); if (!s.length) return 0;
      var pad = parseFloat(getComputedStyle(track).scrollPaddingLeft) || 0;
      var ref = track.getBoundingClientRect().left + pad + 2;
      var best = 0, bestDist = Infinity;
      for (var i = 0; i < s.length; i++) {
        var d = Math.abs(s[i].getBoundingClientRect().left - ref);
        if (d < bestDist) { bestDist = d; best = i; }
      }
      return best;
    }
    function paint(dots, i) {
      if (!dots) return;
      Array.prototype.slice.call(dots.children).forEach(function (d, di) {
        var on = di === i; d.classList.toggle('is-active', on); d.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }
    function init(track) {
      if (!track || track.dataset.ppcBound === '1') return;
      track.dataset.ppcBound = '1';
      var dots = track.parentNode ? track.parentNode.querySelector('[data-pp-dots]') : null;
      var raf = 0;
      function sync() { paint(dots, activeIndex(track)); }
      track.addEventListener('scroll', function () { if (raf) return; raf = requestAnimationFrame(function () { raf = 0; sync(); }); }, { passive: true });
      if (dots) {
        dots.addEventListener('click', function (e) {
          var b = e.target.closest('[data-dot]'); if (!b) return;
          var t = slides(track)[parseInt(b.dataset.dot, 10) || 0];
          if (t && t.scrollIntoView) t.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        });
      }
      window.addEventListener('resize', function () { if (raf) return; raf = requestAnimationFrame(function () { raf = 0; sync(); }); });
      sync();
    }
    function boot() { var els = document.querySelectorAll('[data-pp-carousel]'); for (var i = 0; i < els.length; i++) init(els[i]); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
    return { init: init, boot: boot };
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-single-items"] && !Shopify.designMode) return;
  try {
    
  window.PPCart = window.PPCart || (function () {
    function drawer() { return document.querySelector('cart-drawer'); }
    function sectionsParam(d) {
      var s = 'cart-icon-bubble';
      if (d) { var sec = d.closest('.shopify-section'); if (sec) s += ',' + sec.id.replace('shopify-section-', ''); }
      return s;
    }
    function route() { return (window.theme && theme.routes && theme.routes.cartAdd) ? theme.routes.cartAdd : '/cart/add.js'; }
    /* Shared tail for both add paths: refresh the bubble + drawer, bump, announce. */
    function applyCart(data, d) {
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble && data.sections && data.sections['cart-icon-bubble']) bubble.innerHTML = data.sections['cart-icon-bubble'];
      if (d && typeof d.renderContents === 'function') {
        try { d.renderContents(data, false); } catch (err) { if (typeof d.refresh === 'function') { try { d.refresh(true); } catch (e2) {} } }
      }
      bump();
      document.dispatchEvent(new CustomEvent('on:cart:add', { bubbles: true, detail: { cart: data } }));
      return data;
    }
    async function add(items) {
      var d = drawer();
      var res = await fetch(route(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items, sections: sectionsParam(d), sections_url: window.location.pathname })
      });
      var data = await res.json();
      if (!res.ok) throw data;
      return applyCart(data, d);
    }
    /* A file can only reach a line item property through a MULTIPART body, so an
       upload cannot ride add()'s JSON. Deliberately sets no Content-Type — the
       browser must write its own multipart boundary. One item per call, which is
       all a file upload can be anyway. */
    async function addForm(fd) {
      var d = drawer();
      fd.append('sections', sectionsParam(d));
      fd.append('sections_url', window.location.pathname);
      var res = await fetch(route(), {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: fd
      });
      var data = await res.json();
      if (!res.ok) throw data;
      return applyCart(data, d);
    }
    function bump() {
      var i = document.getElementById('cart-icon');
      if (!i) return;
      i.classList.remove('pp-cart-bump'); void i.offsetWidth; i.classList.add('pp-cart-bump');
      setTimeout(function () { i.classList.remove('pp-cart-bump'); }, 700);
    }
    function reduced() { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
    function fly(img) {
      var icon = document.getElementById('cart-icon');
      if (!icon || !img || reduced()) return;
      var s = img.getBoundingClientRect(), t = icon.getBoundingClientRect();
      if (!s.width || !t.width) return;
      var c = img.cloneNode(true), st = c.style;
      st.position = 'fixed'; st.left = s.left + 'px'; st.top = s.top + 'px'; st.width = s.width + 'px'; st.height = s.height + 'px';
      st.margin = '0'; st.borderRadius = '12px'; st.objectFit = 'cover'; st.zIndex = '9999'; st.pointerEvents = 'none'; st.boxShadow = '0 10px 30px rgba(0,0,0,.25)';
      document.body.appendChild(c);
      var dx = (t.left + t.width / 2) - (s.left + s.width / 2), dy = (t.top + t.height / 2) - (s.top + s.height / 2);
      var a = c.animate([
        { transform: 'translate(0,0) scale(1)', opacity: 1 },
        { transform: 'translate(' + (dx * 0.5) + 'px,' + ((dy * 0.5) - 40) + 'px) scale(.6)', opacity: 0.95, offset: 0.6 },
        { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.12)', opacity: 0.2 }
      ], { duration: 750, easing: 'cubic-bezier(.5,0,.75,.4)' });
      a.onfinish = function () { c.remove(); };
    }
    return { add: add, addForm: addForm, fly: fly, bump: bump };
  })();

  window.PPCarousel = window.PPCarousel || (function () {
    function slides(track) { return Array.prototype.slice.call(track.children); }
    function activeIndex(track) {
      var s = slides(track); if (!s.length) return 0;
      var pad = parseFloat(getComputedStyle(track).scrollPaddingLeft) || 0;
      var ref = track.getBoundingClientRect().left + pad + 2;
      var best = 0, bestDist = Infinity;
      for (var i = 0; i < s.length; i++) {
        var d = Math.abs(s[i].getBoundingClientRect().left - ref);
        if (d < bestDist) { bestDist = d; best = i; }
      }
      return best;
    }
    function paint(dots, i) {
      if (!dots) return;
      Array.prototype.slice.call(dots.children).forEach(function (d, di) {
        var on = di === i; d.classList.toggle('is-active', on); d.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }
    function init(track) {
      if (!track || track.dataset.ppcBound === '1') return;
      track.dataset.ppcBound = '1';
      var dots = track.parentNode ? track.parentNode.querySelector('[data-pp-dots]') : null;
      var raf = 0;
      function sync() { paint(dots, activeIndex(track)); }
      track.addEventListener('scroll', function () { if (raf) return; raf = requestAnimationFrame(function () { raf = 0; sync(); }); }, { passive: true });
      if (dots) {
        dots.addEventListener('click', function (e) {
          var b = e.target.closest('[data-dot]'); if (!b) return;
          var t = slides(track)[parseInt(b.dataset.dot, 10) || 0];
          if (t && t.scrollIntoView) t.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        });
      }
      window.addEventListener('resize', function () { if (raf) return; raf = requestAnimationFrame(function () { raf = 0; sync(); }); });
      sync();
    }
    function boot() { var els = document.querySelectorAll('[data-pp-carousel]'); for (var i = 0; i < els.length; i++) init(els[i]); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
    return { init: init, boot: boot };
  })();

  (function () {
    if (window.__ppSingleBound) return;
    window.__ppSingleBound = true;
    function setLabel(btn, text) { var l = btn.querySelector('.pp-lbl'); if (l) l.textContent = text; else btn.textContent = text; }
    function qtyInput(card) { return card ? card.querySelector('.pp-qty__input') : null; }
    function readQty(card) { var inp = qtyInput(card); var n = inp ? parseInt(inp.value, 10) : 1; if (!n || n < 1 || isNaN(n)) n = 1; return n; }
    function ppMoney(cents, cur) {
      try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur || 'USD' }).format((cents || 0) / 100); }
      catch (e) { return '$' + ((cents || 0) / 100).toFixed(2); }
    }
    function updateTiers(card) {
      if (!card) return;
      var box = card.querySelector('[data-pp-tiers]'); if (!box) return;
      var onlyVid = box.dataset.variantId || '';
      var activeVar = card.querySelector('.pp-si__variant.is-active');
      var atcBtn = card.querySelector('.pp-si__atc');
      var selVid = (activeVar && activeVar.dataset.variantId) || (atcBtn && atcBtn.dataset.variantId) || '';
      var qty = readQty(card);
      var cur = box.dataset.currency || 'USD';
      var cents = parseInt(box.dataset.base, 10) || 0;
      var rows = Array.prototype.slice.call(box.querySelectorAll('.pp-si__tier'));
      var shown = [];
      rows.forEach(function (r) {
        var rv = r.dataset.variantId || '';
        var show = rv ? (rv === selVid) : (!onlyVid || onlyVid === selVid);
        r.hidden = !show;
        r.classList.remove('is-active');
        if (show) shown.push(r);
      });
      box.hidden = shown.length === 0;
      var active = null, bestMin = -1;
      shown.forEach(function (r) {
        var min = parseInt(r.dataset.min, 10) || 0;
        if (qty >= min && min > bestMin) { bestMin = min; active = r; }
      });
      if (active) { active.classList.add('is-active'); cents = parseInt(active.dataset.cents, 10) || cents; }
      var note = box.querySelector('[data-pp-tier-note]');
      if (!note) return;
      note.textContent = cents > 0 ? (qty + ' × ' + ppMoney(cents, cur) + ' each = ' + ppMoney(cents * qty, cur)) : '';
      var refRow = shown[0];
      if (refRow) {
        var tds = refRow.querySelectorAll('td');
        if (tds.length > 1 && document.createRange) {
          try {
            var rng = document.createRange();
            rng.selectNodeContents(tds[1]);
            var offset = rng.getBoundingClientRect().left - box.getBoundingClientRect().left;
            if (offset > 0) note.style.paddingLeft = (Math.round(offset * 100) / 100) + 'px';
          } catch (e) {}
        }
      }
    }
    function selectVariant(btn) {
      if (btn.disabled) return;
      var card = btn.closest('.pp-si__card'); if (!card) return;
      var group = btn.closest('.pp-si__variants');
      if (group) {
        Array.prototype.slice.call(group.querySelectorAll('.pp-si__variant')).forEach(function (b) {
          var on = b === btn;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-checked', on ? 'true' : 'false');
        });
      }
      var atc = card.querySelector('.pp-si__atc');
      if (atc && btn.dataset.variantId) atc.dataset.variantId = btn.dataset.variantId;
      var priceEl = card.querySelector('[data-pp-price]');
      if (priceEl && btn.dataset.price) priceEl.textContent = btn.dataset.price;
      var wasEl = card.querySelector('[data-pp-was]');
      if (wasEl) { var was = btn.dataset.compare || ''; wasEl.textContent = was; wasEl.hidden = !was; }
      var box = card.querySelector('[data-pp-tiers]');
      if (box && btn.dataset.priceCents) box.dataset.base = btn.dataset.priceCents;
      updateTiers(card);
    }
    function initTiers() { Array.prototype.slice.call(document.querySelectorAll('.pp-si__card')).forEach(updateTiers); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTiers); else initTiers();
    document.addEventListener('shopify:section:load', initTiers);
    var ppTierRaf = 0;
    window.addEventListener('resize', function () { if (ppTierRaf) return; ppTierRaf = requestAnimationFrame(function () { ppTierRaf = 0; initTiers(); }); });
    function syncQty(inp) {
      var n = parseInt(inp.value, 10); if (!n || n < 1 || isNaN(n)) n = 1; inp.value = n;
      var wrap = inp.closest('.pp-qty'); if (wrap) { var dec = wrap.querySelector('[data-qty-dec]'); if (dec) dec.disabled = (n <= 1); }
      updateTiers(inp.closest('.pp-si__card'));
    }
    function stepQty(btn, delta) {
      var wrap = btn.closest('.pp-qty'); if (!wrap) return;
      var inp = wrap.querySelector('.pp-qty__input'); if (!inp) return;
      var n = parseInt(inp.value, 10); if (!n || isNaN(n)) n = 1;
      n += delta; if (n < 1) n = 1; inp.value = n; syncQty(inp);
    }
    async function handleAtc(btn) {
      if (btn.disabled || btn.getAttribute('aria-disabled') === 'true' || btn.dataset.busy === '1') return;
      var vid = btn.dataset.variantId; if (!vid) return;
      var card = btn.closest('.pp-si__card'); var img = card ? card.querySelector('.pp-si__img') : null;
      var qty = readQty(card);
      var original = btn.dataset.label || 'Add to Cart';
      btn.dataset.busy = '1'; btn.classList.add('is-loading');
      if (img) window.PPCart.fly(img);
      try {
        await window.PPCart.add([{ id: vid, quantity: qty }]);
        btn.classList.add('is-added'); setLabel(btn, btn.dataset.added || 'Added!');
        var inp = qtyInput(card); if (inp) { inp.value = 1; syncQty(inp); }
        setTimeout(function () { btn.classList.remove('is-added'); setLabel(btn, original); }, 3000);
      } catch (e) {
        setLabel(btn, 'Try again'); setTimeout(function () { setLabel(btn, original); }, 2000);
      } finally { btn.classList.remove('is-loading'); btn.dataset.busy = ''; }
    }
    function collectItems(container, fallbackIds) {
      var items = [];
      container.querySelectorAll('.pp-si__card').forEach(function (card) {
        var atc = card.querySelector('.pp-si__atc[data-variant-id]'); if (!atc) return;
        var id = atc.dataset.variantId; if (!id) return;
        items.push({ id: id, quantity: readQty(card) });
      });
      if (!items.length && fallbackIds) items = fallbackIds.map(function (id) { return { id: id, quantity: 1 }; });
      return items;
    }
    async function handleBundle(btn) {
      if (btn.dataset.state === 'done') { window.location.href = btn.dataset.checkout || '/checkout'; return; }
      if (btn.dataset.busy === '1') return;
      var container = btn.closest('.pp-si');
      var fallback = (btn.dataset.variantIds || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      var items = container ? collectItems(container, fallback) : fallback.map(function (id) { return { id: id, quantity: 1 }; });
      if (!items.length) return;
      btn.dataset.busy = '1'; btn.classList.add('is-loading');
      if (container) { container.querySelectorAll('.pp-si__img').forEach(function (im, i) { setTimeout(function () { window.PPCart.fly(im); }, i * 120); }); }
      try {
        await window.PPCart.add(items);
        btn.dataset.state = 'done'; btn.classList.add('is-done'); setLabel(btn, btn.dataset.doneLabel || 'Bundle in cart, check‑out now!');
      } catch (e) {
        setLabel(btn, 'Try again'); setTimeout(function () { setLabel(btn, btn.dataset.label || 'Add Bundle to Cart'); }, 2000);
      } finally { btn.classList.remove('is-loading'); btn.dataset.busy = ''; }
    }
    document.addEventListener('click', function (e) {
      var vbtn = e.target.closest('.pp-si__variant'); if (vbtn) { e.preventDefault(); selectVariant(vbtn); return; }
      var dec = e.target.closest('.pp-si [data-qty-dec]'); if (dec) { e.preventDefault(); stepQty(dec, -1); return; }
      var inc = e.target.closest('.pp-si [data-qty-inc]'); if (inc) { e.preventDefault(); stepQty(inc, 1); return; }
      var atc = e.target.closest('.pp-si__atc'); if (atc) { e.preventDefault(); handleAtc(atc); return; }
      var b = e.target.closest('.pp-si__bundle'); if (b) { e.preventDefault(); handleBundle(b); return; }
    });
    document.addEventListener('change', function (e) { var inp = e.target.closest('.pp-si .pp-qty__input'); if (inp) syncQty(inp); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qe-artwork-download"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__qeadBound) return;
  window.__qeadBound = true;

  function boot(root) {
    var urlEl = root.querySelector('[data-qead-url]');
    var ordEl = root.querySelector('[data-qead-order]');
    var btn = root.querySelector('[data-qead-go]');
    var msg = root.querySelector('[data-qead-msg]');
    var meta = root.querySelector('[data-qead-meta]');
    if (!urlEl || !btn) return;

    function say(kind, text) {
      msg.hidden = false;
      msg.className = 'qead__msg' + (kind ? ' is-' + kind : '');
      msg.textContent = text;
    }

    function sniff(b) {
      if (b[0] === 0x89 && b[1] === 0x50) return 'png';
      if (b[0] === 0xFF && b[1] === 0xD8) return 'jpg';
      if (b[0] === 0x25 && b[1] === 0x50) return 'pdf';
      if (b[8] === 0x57 && b[9] === 0x45 && b[10] === 0x42 && b[11] === 0x50) return 'webp';
      var head = '';
      for (var i = 0; i < 300 && i < b.length; i++) head += String.fromCharCode(b[i]);
      if (head.indexOf('<svg') !== -1) return 'svg';
      if (head.indexOf('%!PS') !== -1) return 'eps';
      return '';
    }

    btn.addEventListener('click', function () {
      var raw = (urlEl.value || '').trim();
      if (!raw) { say('err', 'Paste the artwork link from the order first.'); return; }
      if (raw.indexOf('cdn.shopify.com') === -1) { say('err', 'That does not look like a Shopify file link.'); return; }

      btn.disabled = true;
      meta.hidden = true;
      say('', 'Downloading the original...');

      fetch(raw, { headers: { Accept: '*/*' } })
        .then(function (r) {
          if (!r.ok) throw new Error('The link returned ' + r.status + '. It may have expired.');
          return r.arrayBuffer();
        })
        .then(function (buf) {
          var bytes = new Uint8Array(buf);
          var kind = sniff(bytes);
          if (kind === 'webp') throw new Error('Still received WebP. Tell the developer, the CDN behaviour changed.');

          var urlExt = (raw.split('?')[0].split('.').pop() || '').toLowerCase();
          var ext = kind || urlExt;
          var order = (ordEl.value || '').trim().replace(/[^A-Za-z0-9_-]/g, '');
          var name = (order ? order + '-artwork' : 'artwork') + '.' + ext;

          var blob = new Blob([bytes]);
          var obj = URL.createObjectURL(blob);
          var a = document.createElement('a');
          a.href = obj; a.download = name;
          document.body.appendChild(a); a.click(); a.remove();
          setTimeout(function () { URL.revokeObjectURL(obj); }, 4000);

          root.querySelector('[data-qead-type]').textContent = ext.toUpperCase();
          root.querySelector('[data-qead-size]').textContent = (bytes.length / 1024).toFixed(0) + ' KB';
          var dims = root.querySelector('[data-qead-dims]');
          var isVector = (ext === 'pdf' || ext === 'eps' || ext === 'ai' || ext === 'svg');
          dims.textContent = isVector ? 'Vector, scales to any size' : '--';
          meta.hidden = false;
          say('ok', 'Saved as ' + name + '.');

          if (ext === 'png' || ext === 'jpg') {
            var im = new Image();
            im.onload = function () {
              dims.textContent = im.naturalWidth + ' x ' + im.naturalHeight + ' px' +
                (Math.min(im.naturalWidth, im.naturalHeight) < 2000 ? ' (under 2000px, may print soft)' : '');
            };
            im.src = URL.createObjectURL(blob);
          }
        })
        .catch(function (e) { say('err', e.message || 'Download failed.'); })
        .then(function () { btn.disabled = false; });
    });
  }

  function init() { document.querySelectorAll('.qead').forEach(boot); }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["support-videos"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function init(root) {
      var blocks = root.querySelectorAll('.sv-block');
      var modal = root.querySelector('[data-sv-modal]');
      var media = modal
        ? modal.querySelector('[data-sv-media]')
        : null;
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      var navEl = root.querySelector('.sv-nav');
      var siteHeader = document.querySelector('store-header[data-is-sticky="true"]') || document.querySelector('store-header') || document.querySelector('.js-header-stuck') || document.querySelector('header');

      function navIsSticky() {
        return navEl && getComputedStyle(navEl).position === 'sticky';
      }
      function headerBottom() {
        if (siteHeader) {
          var b = siteHeader.getBoundingClientRect().bottom;
          return b > 0
            ? b
            : 0;
        }
        return parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 0;
      }
      function syncNavTop() {
        if (! navEl) return;
        
        if (navIsSticky()) 
          navEl.style.top = headerBottom() + 'px';
         else 
          navEl.style.top = '';
        
      }
      var rafPending = false;
      function onScroll() {
        if (rafPending) return;
        
        rafPending = true;
        requestAnimationFrame(function() {
          syncNavTop();
          rafPending = false;
        });
      }
      window.addEventListener('scroll', onScroll, {passive: true});
      window.addEventListener('resize', onScroll);
      syncNavTop();

      function scrollToBlock(b) {
        var behavior = reduceMotion
          ? 'auto'
          : 'smooth';
        function targetY() {
          var off = headerBottom() + (
            navIsSticky()
              ? navEl.offsetHeight
              : 0
          ) + 8;
          return Math.max(b.getBoundingClientRect().top + window.pageYOffset - off, 0);
        }
        window.scrollTo({top: targetY(), behavior: behavior});

// The header expands on scroll-up and collapses on scroll-down (~0.3s),
// which shifts the target after the scroll begins. Re-measure live and
// re-align until it settles (handles both transform- and reflow-based headers).
        var passes = 0;
        function settle() {
          var y = targetY();
          if (Math.abs(window.pageYOffset - y) > 3 && passes < 6) {
            passes += 1;
            window.scrollTo({top: y, behavior: behavior});
            setTimeout(settle, 220);
          }
        }
        setTimeout(settle, 400);
      }

      function closeAll(except) {
        blocks.forEach(function(b) {
          if (b !== except) {
            b.classList.remove('open');
            var h = b.querySelector('.sv-sec-head');
            if (h) 
              h.setAttribute('aria-expanded', 'false');
            
          }
        });
      }
      function blockHandle(b) {
        return b.id.indexOf('sv-block-') === 0
          ? b.id.slice(9)
          : b.id;
      }
      function openBlock(b, scroll) {
        closeAll(b);
        b.classList.add('open');
        var h = b.querySelector('.sv-sec-head');
        if (h) 
          h.setAttribute('aria-expanded', 'true');
        
        if (history.replaceState) {
          try {
            history.replaceState(null, '', '#' + blockHandle(b));
          } catch (e) {}
        }
        if (scroll) 
          scrollToBlock(b);
        
      }

      root.querySelectorAll('.sv-nav-btn').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var target = btn.getAttribute('data-target');
          var b = root.querySelector('[id="sv-block-' + target + '"]');
          if (b) {
            openBlock(b, true);
            var h = b.querySelector('.sv-sec-head');
            if (h) 
              h.focus({preventScroll: true});
            
          }
        });
      });

      root.querySelectorAll('.sv-sec-head').forEach(function(h) {
        h.addEventListener('click', function() {
          var b = h.closest('.sv-block');
          if (b.classList.contains('open')) {
            b.classList.remove('open');
            h.setAttribute('aria-expanded', 'false');
          } else {
            openBlock(b, true);
          }
        });
      });

      function openFromHash() {
        var raw = (window.location.hash || '').slice(1);
        if (! raw) return;
        
        raw = decodeURIComponent(raw);
        var b = root.querySelector('[id="sv-block-' + raw + '"]') || root.querySelector('[id="' + raw + '"]');
        if (b && b.classList.contains('sv-block')) 
          openBlock(b, true);
        
      }
      window.addEventListener('hashchange', openFromHash);
      setTimeout(openFromHash, 60);

      function openModal(card) {
        if (! modal) return;
        
        var yt = card.getAttribute('data-yt');
        var file = card.getAttribute('data-file');
        var title = card.getAttribute('data-title') || 'Video';
        modal.querySelector('[data-sv-title]').textContent = title;
        modal.querySelector('[data-sv-desc]').textContent = card.getAttribute('data-desc') || '';
        media.innerHTML = '';
        if (yt) {
          var frame = document.createElement('iframe');
          frame.title = title;
          frame.allow = 'autoplay; encrypted-media; fullscreen';
          frame.setAttribute('allowfullscreen', '');
          frame.src = 'https://www.youtube.com/embed/' + yt + '?autoplay=1&rel=0';
          media.appendChild(frame);
        } else if (file) {
          var vid = document.createElement('video');
          vid.controls = true;
          vid.autoplay = true;
          vid.playsInline = true;
          vid.setAttribute('title', title);
          vid.src = file;
          media.appendChild(vid);
        } else {
          media.innerHTML = '<div class="sv-modal-ph">This video will be available soon.</div>';
        }
        if (typeof modal.showModal === 'function') 
          modal.showModal();
         else 
          modal.setAttribute('open', '');
        
      }
      function closeModal() {
        if (media) 
          media.innerHTML = '';
        
        if (typeof modal.close === 'function') {
          try {
            modal.close();
          } catch (e) {}
        } else 
          modal.removeAttribute('open');
        
      }

      root.querySelectorAll('.sv-card').forEach(function(card) {
        card.addEventListener('click', function() {
          openModal(card);
        });
      });
      if (modal) {
        modal.querySelector('[data-sv-close]').addEventListener('click', closeModal);
        modal.addEventListener('click', function(e) {
          if (e.target === modal) 
            closeModal();
          
        });
        modal.addEventListener('cancel', function(e) {
          e.preventDefault();
          closeModal();
        });
      }

      root.querySelectorAll('.sv-share-copy').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var url = btn.getAttribute('data-copy');
          var inp = btn.parentNode.querySelector('.sv-share-input');
          var done = function() {
            btn.textContent = 'Copied!';
            setTimeout(function() { btn.textContent = 'Copy'; }, 1500);
          };
          function legacyCopy() {
            if (!inp) return false;
            inp.focus();
            inp.setSelectionRange(0, inp.value.length);
            try { return document.execCommand('copy'); } catch (e) { return false; }
          }
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(url).then(done, function() { if (legacyCopy()) done(); });
          } else if (legacyCopy()) {
            done();
          }
        });
      });
    }
    document.querySelectorAll('[data-sv]').forEach(init);
    document.addEventListener('shopify:section:load', function(e) {
      var root = (e.target || document).querySelector('[data-sv]');
      if (root) init(root);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
